export default "* Snor\n* Bast";